import React from 'react'
import { getFinanceLinks, getPagesBySlug, getReplaceStudentPlanIdentifier } from '../../services/reservoir'
import { connect } from 'react-redux'
import parse from 'html-react-parser';
import Loading from '../tags/Loading'
import { getPersonalDetails } from '../../services/vu'
import { formatDate } from '../../actions/dateUtility';
import classNames from 'classnames';

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse }, currentUser }) => {
  return {
    admissionCategory: selectedCourse.admissionCategory,
    userId: currentUser.data['vuId'],
    courseId: selectedCourseCode,
    versionNo: selectedCourse.versionNumber,
    attemptNo: selectedCourse.attemptNumber
  }
}

class Finances extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loadingPage: true,
      personalDetails: {
        studentId: '',
        dateOfBirth: ''
      },
      content: null,
      financeLinks: []
    }
  }

  componentDidMount() {
    this.loadFinancesPage()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.admissionCategory !== this.props.admissionCategory) {
      this.loadFinancesPage()
    }
  }

  loadFinancesPage = () => {
    this.setState({
      loadingPage: true
    })

    Promise.all([getPersonalDetails(), getPagesBySlug('finances', this.props.admissionCategory), getFinanceLinks(this.props.admissionCategory)]).then(
      ([personalDetails, page, financeLinks]) => {
        this.setState({
          loadingPage: false,
          personalDetails: personalDetails,
          content: page && page.data && page.data.length > 0 && page.data[0].attributes && page.data[0].attributes.body && page.data[0].attributes.body.value,
          financeLinks: financeLinks
        })
      }
    )
  }

  render() {
    if (this.state.loadingPage) {
      return <Loading />
    }

    return (
      <div>
        <div className="page">
          <div className="secondary-page__container secondary-page__container--narrow">
            {parse(this.state.content)}

            {this.state.financeLinks && this.state.financeLinks.length > 0 ? (
              <div className="button-panel-container">
                {this.state.financeLinks.map((financeLink, index, financeLinks) => {
                  if (financeLink.attributes.field_onestop_override) {
                    return (
                      <form action={financeLink.attributes.field_slug} method="post" key={financeLink.id}>
                        <input type="hidden" id="tran-type" name="tran-type" value="ESB001" />
                        <input type="hidden" id="ESBStudentId" name="ESBStudentId" value={`ST${this.state.personalDetails.studentId}`} />
                        <input type="hidden" id="ESBStudentDateOfBirth" name="ESBStudentDateOfBirth" value={formatDate(this.state.personalDetails.dateOfBirth, 'dd/MM/yyyy')} />
                        <button type="submit" className={classNames('button-panel', { 'button-panel--last': index === financeLinks.length - 1 })}>
                          {financeLink.attributes && financeLink.attributes.field_heading_myvu_ && <h2>{financeLink.attributes.field_heading_myvu_}</h2>}
                          {financeLink.attributes && financeLink.attributes.body && financeLink.attributes.body.value && <div>{parse(financeLink.attributes.body.value)}</div>}
                        </button>
                      </form>
                    )
                  }

                  return (
                    <a
                      className={classNames('button-panel', { 'button-panel--last': index === financeLinks.length - 1 })}
                      key={financeLink.id}
                      href={
                        financeLink.attributes.field_slug.includes('$STDPLNID_MYVU$')
                          ? getReplaceStudentPlanIdentifier(financeLink.attributes.field_slug, this.props.userId, this.props.courseId, this.props.versionNo, this.props.attemptNo)
                          : financeLink.attributes.field_slug
                      }
                    >
                      {financeLink.attributes && financeLink.attributes.field_heading_myvu_ && <h2>{financeLink.attributes.field_heading_myvu_}</h2>}
                      {financeLink.attributes && financeLink.attributes.body && financeLink.attributes.body.value && <span>{parse(financeLink.attributes.body.value)}</span>}
                    </a>
                  )
                })}
              </div>
            ) : (
              <p>There are currently no links available.</p>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(Finances)
